<div class="mh-welcome-page">
  <div class="welcome-container">
    <!-- Loading Step -->
    <div *ngIf="currentStep === WelcomePageStep.LOADING" class="loading-step">
      <div class="text-center">
        <nz-spin nzSize="large"></nz-spin>
        <h2 class="loading-title">{{ "user-bridge.loading.title" | translate }}</h2>
      </div>
    </div>

    <!-- Welcome Step -->
    <div *ngIf="currentStep === WelcomePageStep.WELCOME" class="welcome-step">
      <div class="welcome-header">
        <img src="/assets/images/logo.svg" alt="Oceans Million Logo" class="logo" />
        <h1>{{ "user-bridge.welcome.title" | translate }}</h1>
      </div>

      <div class="welcome-content">
        <div class="user-info">
          <h2>{{ "user-bridge.welcome.greeting" | translate : { name: userInfo?.name } }}</h2>
          <p>{{ "user-bridge.welcome.description" | translate }}</p>
          <p>
            {{ "user-bridge.welcome.email-info" | translate }}: <strong>{{ userInfo?.email }}</strong>
          </p>
        </div>

        <form [formGroup]="welcomeForm" (ngSubmit)="onAcceptTerms()">
          <div class="terms-section">
            <h3>{{ "user-bridge.terms.title" | translate }}</h3>
            <div class="terms-content">
              <p>
                {{ "user-bridge.terms.description" | translate }}
              </p>
              <div class="terms-links">
                <a [href]="termsUrl" target="_blank">{{ "user-bridge.terms.terms-link" | translate }}</a> |
                <a [href]="privacyUrl" target="_blank">{{ "user-bridge.terms.privacy-link" | translate }}</a>
              </div>
            </div>

            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="acceptNewsletter" class="newsletter-checkbox">
                  {{ "user-bridge.newsletter.accept-label" | translate }}
                </label>
              </nz-form-control>
            </nz-form-item>

            <nz-form-item>
              <nz-form-control>
                <label nz-checkbox formControlName="acceptTerms" class="terms-checkbox">
                  {{ "user-bridge.terms.accept-label" | translate }}
                </label>
                <div
                  *ngIf="welcomeForm.get('acceptTerms')?.touched && welcomeForm.get('acceptTerms')?.invalid"
                  class="error-text"
                >
                  {{ "user-bridge.terms.accept-error" | translate }}
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div class="actions">
            <button nz-button nzType="primary" nzSize="large" [nzLoading]="isLoading">
              {{ "user-bridge.welcome.create-account-btn" | translate }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <!-- Set Password Step -->
    <div *ngIf="currentStep === WelcomePageStep.SET_PASSWORD" class="password-step">
      <div class="step-header">
        <h1>{{ "user-bridge.password.title" | translate }}</h1>
        <p>{{ "user-bridge.password.description" | translate }}</p>
      </div>

      <form [formGroup]="passwordForm" (ngSubmit)="onSetPassword()" class="password-form" nz-form nzLayout="vertical">
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ "user-bridge.password.label" | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24" nzDisableAutoTips>
            <input
              nz-input
              nzSize="large"
              type="password"
              [placeholder]="'user-bridge.password.placeholder' | translate"
              formControlName="password"
              minlength="8"
              autocomplete="new-password"
            />
            <mh-password-validation-tips [passwordControl]="password"></mh-password-validation-tips>
          </nz-form-control>
        </nz-form-item>

        <div class="actions">
          <button nz-button nzType="primary" nzSize="large" [nzLoading]="isLoading">
            {{ "user-bridge.password.set-password-btn" | translate }}
          </button>
        </div>
      </form>
    </div>

    <!-- Set Reason Why Step -->
    <div *ngIf="currentStep === WelcomePageStep.SET_REASON_WHY" class="reason-why-step">
      <div class="step-header">
        <h1>{{ "user-bridge.reason-why.title" | translate }}</h1>
        <p>{{ "user-bridge.reason-why.description" | translate }}</p>
      </div>

      <form
        [formGroup]="profileInfoForm"
        (ngSubmit)="onSetReasonWhy()"
        class="reason-why-form"
        nz-form
        nzLayout="vertical"
      >
        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ "user-bridge.reason-why.label" | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24" nzDisableAutoTips>
            <nz-radio-group formControlName="reasonWhy">
              <label nz-radio *ngFor="let option of reasonWhyOptions$ | async" [nzValue]="option">
                <span [innerHTML]="option.name | translate"></span>
              </label>
            </nz-radio-group>
            <div
              *ngIf="profileInfoForm.get('reasonWhy')?.touched && profileInfoForm.get('reasonWhy')?.invalid"
              class="error-text"
            >
              {{ "user-bridge.reason-why.error" | translate }}
            </div>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired>{{ "user-bridge.gender.label" | translate }}</nz-form-label>
          <nz-form-control [nzSpan]="24" nzDisableAutoTips>
            <nz-select
              formControlName="gender"
              [nzPlaceHolder]="'user-bridge.gender.placeholder' | translate"
              [compareWith]="compareCmsNameValue"
            >
              <nz-option
                *ngFor="let option of genderOptions$ | async"
                [nzValue]="option"
                [nzLabel]="option.name | translate"
              ></nz-option>
            </nz-select>
            <div
              *ngIf="profileInfoForm.get('gender')?.touched && profileInfoForm.get('gender')?.invalid"
              class="error-text"
            >
              {{ "user-bridge.gender.error" | translate }}
            </div>
          </nz-form-control>
        </nz-form-item>

        <div class="actions">
          <button nz-button nzType="primary" nzSize="large" [nzLoading]="isLoading">
            {{ "user-bridge.reason-why.continue-btn" | translate }}
          </button>
        </div>
      </form>
    </div>

    <!-- Success Step -->
    <div *ngIf="currentStep === WelcomePageStep.SUCCESS" class="success-step">
      <div class="success-content">
        <nz-result
          nzStatus="success"
          [nzTitle]="'user-bridge.success.title' | translate"
          [nzSubTitle]="'user-bridge.success.description' | translate"
        >
          <div nz-result-extra>
            <button nz-button nzType="primary" (click)="goToDashboard()">
              {{ "user-bridge.success.continue-btn" | translate }}
            </button>
          </div>
        </nz-result>
      </div>
    </div>

    <!-- Error Step -->
    <div *ngIf="currentStep === WelcomePageStep.ERROR" class="error-step">
      <div class="error-content">
        <nz-result nzStatus="error" [nzTitle]="'user-bridge.error.title' | translate" [nzSubTitle]="errorMessage">
          <div nz-result-extra>
            <button nz-button nzType="primary" (click)="goToLogin()">
              {{ "user-bridge.error.go-to-login-btn" | translate }}
            </button>
          </div>
        </nz-result>
      </div>
    </div>
  </div>
</div>
